<div class="history" infiniteScroll [infiniteScrollDistance]="page" [infiniteScrollThrottle]="pageSize"
  (scrolled)="onScroll()" [scrollWindow]="false">
  <div *ngFor="let statement of historyStatement; let i = index">
    <div class="detail" [ngClass]="statement.transactionStatus.toLowerCase()">
      <span class="chbox" (click)="selectTransaction(statement)" [class.active]="statement.active"
        *ngIf="transactionRecord && (normalTab || cardTab || interBankTab)" [id]="'checkbox' + i">
        <img src="assets/img/List-chkbox-inactive.svg" alt="" class="chbox-deactive">
        <img src="assets/img/List-chkbox-active.svg" alt="" class="chbox-active">
      </span>

      <div class="d-flex align-items-center" (click)="showReciept(statement)" style="width: 100%"
        [class.not_full]="transactionRecord && (normalTab || cardTab || interBankTab)">
        <img [src]="getSrc(statement)" alt="">
        <div class="d-flex ml-auto flex-column limit_text"
          [class.limit_text_small]="transactionRecord && (normalTab || cardTab || interBankTab)">
          <span class="novin-font-bold">{{statement.transactionTypeNameFa}}
            <span *ngIf="statement?.fundTransferDetails"> -
              {{statement.fundTransferDetails.destinationCardOwnerName}}</span>
          </span>
          <span class="bottomSpan novin-font ">{{statement.paymentCardName}}</span>
        </div>
        <div class="d-flex flex-column" style="text-align: left;">
<!--          <span class="topSpan" [class.warning]="statement?.transactionStatus.toLowerCase() ==='success' &&-->
<!--          statement.resourceType === 'Deposit' && statement.fundTransferDetails?.destResourceType === 'IBAN'">{{statement.amount | number}} ریال</span>-->
          <span class="topSpan">{{statement.amount | number}} ریال</span>
          <span class="bottomSpan">{{statement.transactionDate | jalaliConvertor}}</span>
        </div>
      </div>
    </div>
    <div *ngIf="statement?.label" class="description">
      {{statement?.label}}
    </div>
  </div>


  <div class="bt-spinner-container">
    <div *ngIf="pageLoading" class="bt-spinner"></div>
  </div>
</div>
